import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fffb50d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_2 = {
  key: 1,
  class: "m-5 text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-3" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Loading... ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " To automatically share distributed assets with a user group please specify the custom property used in the Dynamic User Group. Specify the custom property for every client you want the app to work on. ", -1))
const _hoisted_8 = { width: "100%" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Client"),
    /*#__PURE__*/_createElementVNode("th", null, "Custom Property")
  ])
], -1))
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "alert alert-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.error), 1))
      : (!_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, clientIdx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: clientIdx }, [
                    _createElementVNode("td", null, _toDisplayString(client.clientName), 1),
                    _createElementVNode("td", null, [
                      (client.auth)
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            class: "form-control form-override",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.dynamicUserGroupCustomProp[client.clientId]) = $event)
                          }, [
                            _hoisted_11,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.customProps, (prop, propIdx) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: propIdx,
                                value: prop.fieldName
                              }, _toDisplayString(prop.label.en), 9, _hoisted_12))
                            }), 128))
                          ], 8, _hoisted_10)), [
                            [_vModelSelect, _ctx.dynamicUserGroupCustomProp[client.clientId]]
                          ])
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, " Could'nt retrieve custom properties for this client. The user which authenticated the app is probably not authorized. "))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
  ]))
}